import { render, staticRenderFns } from "./newDetails.vue?vue&type=template&id=4f9b9b3d&"
import script from "./newDetails.vue?vue&type=script&lang=js&"
export * from "./newDetails.vue?vue&type=script&lang=js&"
import style0 from "./newDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports